const addOneDay = (iso) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
};

const span = (s) => new Date(s.end) - new Date(s.start);

export const seasonFor = (property, iso) =>
  (property.season_prices || [])
    .filter((s) => s.start <= iso && iso <= s.end)
    .sort((a, b) => span(a) - span(b))[0];

export const stayPrice = (property, checkin, checkout) => {
  const base = Number(property.price_per_night || 0);
  let total = 0;
  let special = 0;
  let nights = 0;
  for (let d = checkin; d < checkout; d = addOneDay(d)) {
    const sp = seasonFor(property, d);
    total += sp ? Number(sp.price) : base;
    if (sp) special += 1;
    nights += 1;
    if (nights > 400) break;
  }
  return { total, special, nights };
};

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
